import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { EventiProgrammaSection as Original } from 'components/organisms'
import {
  EventiProgrammaSectionSettings,
  EventiProgrammaSectionFloatingSettings,
} from './EventiProgrammaSectionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'
import { getItemChildren } from 'react-pagebuilder/utils/node'
import { calendarDateCardItemParams } from '../CalendarDateCard'

export const defaultProps = {}

export const eventiProgrammaSectionItemParams = (enabled, id, blockProps, children) => ({
  pk: id,
  name: getTextEditor(children?.[0], enabled),
  children: getItemChildren(enabled, children?.[1], calendarDateCardItemParams),
})

export const dynamicProps = []

export const EventiProgrammaSection: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={`block-eventi-programma-section ${props.className}`}
      >
        <Original
          item={eventiProgrammaSectionItemParams(enabled, id, blockProps, children)}
          editMode={enabled}
        />
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

EventiProgrammaSection.craft = withCraft({
  name: 'EventiProgrammaSection',
  defaultProps: defaultProps,
  settings: EventiProgrammaSectionSettings,
  floatingSettings: EventiProgrammaSectionFloatingSettings,
})
